/**
 * Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UpdateUserMiningCommissionItem } from './update-user-mining-commission-item';


export interface UpdateUserMiningCommissionsRequest { 
    userId: string;
    items: Array<UpdateUserMiningCommissionItem>;
}

